import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import logo from "../images/logoGT.png";
import NavLinks from "./NavLinks";

/**
 * Represents the header component containing the logo and navigation links.
 *
 * @component
 */

const Header = () => {
  return (
    <header className="header">
      {/* Link to the home page */}
      <NavLink to="/">
        {/* Animated logo */}
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 2, duration: 0.5, type: "spring" }}>
          {/* Animated logo image */}
          <motion.img
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.9 }}
            className="logo"
            src={ logo }
            alt="Gerardo Turin' Logo"
            style={{ filter: "brightness(150%)" }}

          />
        </motion.div>
      </NavLink>

      <NavLinks />
    </header>
  );
};

export default Header;
